export default{
    init(){
        this.articleCategoryActions();
        this.saveCategory();
        this.articlesActions();
    },
    articleCategoryActions(){
        $('body').on('click', '#create-article-category, #create-first-article-category', (e)=>{
            e.preventDefault();
            this.getForm({form_type:'create', entity: 'category'}, ()=>{$('#create_category_form').modal('show');});
        });
        $('body').on('click', '.edit-article-category', (e)=>{
            e.preventDefault();
            this.getForm({form_type:'edit', entity: 'category', id: $(e.currentTarget).parents('tr').data('id')}, ()=>{
                $('#edit_category_form').modal('show');
                this.selectImageListeners();
            });
        });
        $('body').on('click', '.delete-article-category', function (e) {
            e.preventDefault();
            if (!window.confirm('Delete this category? This cannot be undone.')) return;
            const id = $(this).parents('tr').data('id');
            $.ajax({
                method: 'POST',
                url: `/admin/articles-management/category/${id}/delete`,
                success: () => location.reload(true),
                error: (response) => window.alert(response.responseJSON?.message || 'Unable to delete this category.'),
            });
        });
    },
    saveCategory(){
        $('body').on('click', '.save-article-category', function(e) {
            e.preventDefault();
            const button = $(this);
            const modal = button.closest('.modal');
            const form = modal.find('.article-category-form');
            const error = form.find('[data-category-error]');
            const title = form.find('[name="title"]').val().trim();
            const link = form.find('[name="link"]').val().trim();

            error.addClass('d-none');
            if (!title || !link) {
                error.find('[data-category-error-message]').text('Add both a title and URL path before saving.');
                error.removeClass('d-none');
                return;
            }

            button.attr('disabled', 'disabled');
            const formData = new FormData();
            formData.append('parent_id', form.find('[name="parent"]').val() || '');
            formData.append('title', title);
            formData.append('link', link);
            formData.append('id', form.find('[name="id"]').val());
            formData.append('logo', form.find('#category-logo')[0].files[0] ?? '');

            $.ajax({
                method: 'POST',
                url: '/admin/articles-management/category/create',
                data: formData,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: () => location.reload(true),
                error: (response) => {
                    error.find('[data-category-error-message]').text(response.responseJSON?.message || 'Unable to save this category.');
                    error.removeClass('d-none');
                    button.removeAttr('disabled');
                },
            });
        });
    },
    getForm(data, successCallback = ()=>{}, errCallback = ()=>{}){
        $.ajax({
            method: 'GET',
            url: '/admin/articles-management/category/get-form',
            data: data,
            success:(response)=>{
                $('#form-container').html(response);
                successCallback();
            },
            error: errCallback,
        });
    },
    articlesActions(){
        $('#articles-mangement').on('change', '#article-category-filter', function() {
            const category = $(this).val();
            location.href = category === 'all' ? location.pathname : `${location.pathname}?category=${category}`;
        });
    },
    selectImageListeners(){
        $('#category-logo').on('change', (e)=>{
            const label = $('.select-image-label');
            const fileName = e.target.files[0]?.name;
            label.toggleClass('is-invalid', !fileName);
            if (fileName) label.find('.content-admin-file-picker__copy span').text(fileName);
        });
    }
}
